import { useTranslation } from "react-i18next"
import { Box, Button, Flex, Link, LinkButton, Typography } from "@strapi/design-system"
import { ArrowLeft, Check } from "@strapi/icons"

export const HEADER_HEIGHT = "120px"

interface FixedHeaderLayoutProps {
  title: string
  onFirstButtonClicked: () => void
  onSecondButtonClicked?: () => void
  onBack?: () => void
  isFirstButtonDisabled?: boolean
  onFirstButtonLoading?: boolean
  onSecondButtonLoading?: boolean
  validateSecondButton?: () => boolean
  secondButtonDisabled?: boolean
}

export const FixedHeaderLayout: React.FC<FixedHeaderLayoutProps> = ({
  title,
  onFirstButtonClicked,
  onSecondButtonClicked,
  onBack,
  secondButtonDisabled = false,
  isFirstButtonDisabled = false,
  onSecondButtonLoading = false,
  onFirstButtonLoading = false,
  validateSecondButton,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Box
        style={{
          height: HEADER_HEIGHT,
          minWidth: "800px",
          marginBottom: "10px",
        }}
      />
      <Box
        background="neutral100"
        style={{
          position: "fixed",
          top: 0,
          zIndex: 1,
          padding: "24px 256px 24px 56px",
          height: HEADER_HEIGHT,
          minWidth: "800px",
          width: "100%",
        }}
      >
        <Flex justifyContent="space-between" alignItems="end">
          <Flex gap={2} alignItems="start" direction="column">
            <Box
              onClick={onBack}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <Link onClick={onBack}>
                <ArrowLeft />
              </Link>
              <Typography textColor="primary600" style={{ paddingBottom: "4px" }}>
                {t("backToProducts")}
              </Typography>
            </Box>
            <Typography
              as="h1"
              variant="beta"
              style={{
                fontSize: "32px",
                fontWeight: 600,
                lineHeight: "32px",
                textAlign: "left",
              }}
            >
              {title}
            </Typography>
          </Flex>

          <Flex gap={2}>
            <LinkButton
              variant="secondary"
              loading={onFirstButtonLoading || undefined}
              onClick={onFirstButtonClicked}
              disabled={isFirstButtonDisabled}
            >
              {t("cancel")}
            </LinkButton>
            <Button
              startIcon={<Check />}
              loading={onSecondButtonLoading || undefined}
              onClick={() => {
                if (validateSecondButton()) onSecondButtonClicked()
              }}
              disabled={secondButtonDisabled}
            >
              {t("save")}
            </Button>
          </Flex>
        </Flex>
      </Box>
    </>
  )
}
